// Compact Star Rating - Independent functionality
document.addEventListener('DOMContentLoaded', async function () {
  const storeId = 'deaa9020-a45c-4498-b3f0-e8ab824b11e1';
  const compactRating = document.querySelector('.compact-star-rating');
  if (!compactRating) return;

  // Check if reviews section exists and add click listener only if it does
  const reviewsSection = document.querySelector('[data-section-type="api-reviews"]');

  if (reviewsSection) {
    compactRating.style.cursor = 'pointer';
    compactRating.addEventListener('click', scrollToReviews);
  } else {
    compactRating.style.cursor = 'default';
  }

  let reviewData = { total_review: 0, average_score: 0 };

  try {
    const siteUrl = `https://api.okendo.io/v1/stores/${storeId}/review_aggregate`;
    const siteResponse = await fetch(siteUrl);
    const siteData = await siteResponse.json();

    if (siteData?.reviewAggregate) {
      reviewData = {
        total_review: siteData.reviewAggregate.reviewCount || 0,
        average_score: 5 // Hardcoded to 5 stars since API returns 0
      };
    }
    updateCompactRating(reviewData.average_score, reviewData.total_review);

  } catch (error) {
    // Fallback: try to get data from existing Okendo elements
    const existingOkendoData = document.querySelector('[data-oke-metafield-data]');
    if (existingOkendoData) {
      try {
        const data = JSON.parse(existingOkendoData.textContent);
        updateCompactRating(data.averageRating, data.reviewCount);
      } catch (e) {
      }
    }
  }
});

function updateCompactRating(averageRating, reviewCount) {
  const compactRating = document.querySelector('.compact-star-rating');
  if (!compactRating) {
    return;
  }

  const starsContainer = compactRating.querySelector('.stars-foreground');
  const reviewCountElement = compactRating.querySelector('.review-count');
  const reviewLabelElement = compactRating.querySelector('.review-label');

  if (starsContainer && averageRating) {
    const percentage = (parseFloat(averageRating) / 5) * 100;
    starsContainer.style.width = percentage + '%';
  }

  if (reviewCountElement && reviewCount !== undefined) {
    animateCount(reviewCountElement, reviewCount);
  }

  if (reviewLabelElement && reviewCount !== undefined) {
    reviewLabelElement.textContent = reviewCount === 1 ? 'Review' : 'Reviews';
  }
}

function animateCount(element, targetCount) {
  const duration = 1500; // 1.5 seconds
  const startTime = performance.now();
  const startCount = 0;

  function updateCount(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    // Use easeOutQuart for smooth deceleration
    const easeProgress = 1 - Math.pow(1 - progress, 4);
    const currentCount = Math.floor(startCount + (targetCount - startCount) * easeProgress);

    element.textContent = currentCount;

    if (progress < 1) {
      requestAnimationFrame(updateCount);
    } else {
      element.textContent = targetCount; // Ensure final value is exact
    }
  }

  requestAnimationFrame(updateCount);
}

function scrollToReviews() {
  const reviewsSection = document.querySelector('[data-section-type="api-reviews"]') ||
    document.querySelector('.okendo-reviews-wrapper') ||
    document.querySelector('[data-oke-reviews-product-id]');

  if (reviewsSection) {
    reviewsSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
